module.exports = __webpack_public_path__ + "img/256_Third of Brookfield_Lobby_cam02_D4.07d07a29.jpg";